<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link :to="{ path: '/setup/broadcaster-channel' }" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>{{ channelById.channelName }}</td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteChannelPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ChannelName") }}</b>
                    </td>
                    <td>{{ channelById.channelName }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ChannelCategory") }}</b>
                    </td>
                    <td>{{ channelById.channelCategory }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ChannelType") }}</b>
                    </td>
                    <td>{{ channelById.channelType }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.IsLocalChannel") }}</b>
                    </td>
                    <td>{{ channelById.isLocalChannel }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.IsHdChannel") }}</b>
                    </td>
                    <td>{{ channelById.isHdChannel }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ChannelSequence") }}</b>
                    </td>
                    <td>{{ channelById.channelSequence }}</td>
                  </tr>
                  <tr>
                    <td class="border-none">
                      <b>{{ $t("setup.label.BroadcasterName") }} </b>
                    </td>
                    <td class="border-none">
                      {{ channelById.broadcasterName }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteChannelPopup"
      :title="$t('setup.label.Channel')"
      @deletePressed="deleteChannel()"
      @cancelPressed="deleteChannelPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deleteChannelPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      channelById: (state) => state.broadcaster.channelById,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    async deleteChannel() {
      this.deleteChannelPopup = false;
      try {
        await this.$store.dispatch(
          "broadcaster/deleteChannelAction",
          this.$route.params.id
        );
        this.$router.push({ path: "/setup/broadcaster-channel" });
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async getChannelById() {
      try {
        await this.$store.dispatch(
          "broadcaster/setChannelById",
          this.$route.params.id
        );
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    editData(id) {
      this.$router.push({
        name: "Edit Channel",
        params: { id: this.$route.params.id },
      });
    },
  },
  mounted() {
    this.getChannelById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
